import "core-js/modules/es.array.concat.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import util from '@/libs/util.js';
export default {
  methods: {
    set: function set() {
      var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'default-name';
      var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'default-value';
      util.cookies.set(name, value);
      this.$message.info("\u8BBE\u7F6E\u6570\u636E ".concat(name, " = ").concat(value));
    },
    setExpires: function setExpires() {
      var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'default-name';
      var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'default-value';
      var expires = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      util.cookies.set(name, value, {
        expires: expires
      });
      this.$message.info("\u8BBE\u7F6E\u6570\u636E ".concat(name, " = ").concat(value, " \u6709\u6548\u671F ").concat(expires, " \u5929"));
    },
    get: function get() {
      var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'default-name';
      var value = util.cookies.get(name);
      this.$message.info("\u83B7\u53D6\u6570\u636E ".concat(name, " = ").concat(value));
    },
    getAll: function getAll() {
      var value = util.cookies.getAll();
      console.log(value);
      this.$message.info('结果已经打印到控制台');
    },
    remove: function remove() {
      var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'default-name';
      util.cookies.remove(name);
      this.$message.info("\u5220\u9664\u6570\u636E ".concat(name));
    }
  }
};